import React from 'react'

const Team = ({className}) => (
  <div className={`team ${className}`} id="team">
    <h2 className="team-title">The team</h2>

    <div className="team-list">
      <div className="team-list_item">
        <h3 className="team-list_name">Eva Ferreira</h3>
        <a className="team-list_link" target="_blank" href="https://twitter.com/evaferreira92">@evaferreira92</a>
      </div>
      <div className="team-list_item">
        <h3 className="team-list_name">Alejandro Gerbec</h3>
        <a className="team-list_link" target="_blank" href="https://twitter.com/alejandrogerbec">@alejandrogerbec</a>
      </div>
      <div className="team-list_item">
        <h3 className="team-list_name">Gabrielle Gatti</h3>
        <a className="team-list_link" target="_blank" href="https://twitter.com/belligera">@belligera</a>
      </div>
      <div className="team-list_item team-family">
        {/*<a href="#" className="team-family_2016 item-link_arrow">2016 edition</a>*/}
        <p className="team-family_text">
          Part of the <a href="http://cssconf.org/" target="_blank">CSSConf family</a>
        </p>
      </div>
    </div>
  </div>
)

console.log("Coded with love by @evaferreira92 during the Easter Holidays. Designed with love by @belligera. Easter eggs will be uploaded soon.");

Team.defaultProps = {
  className: ""
}

export default Team;


// WEBPACK FOOTER //
// ./src/components/Team/index.js